__turbopack_context__.v({
  "card": "instructions-module-scss-module__SZUyba__card",
  "cardDescription": "instructions-module-scss-module__SZUyba__cardDescription",
  "cardImage": "instructions-module-scss-module__SZUyba__cardImage",
  "cardNumber": "instructions-module-scss-module__SZUyba__cardNumber",
  "cardText": "instructions-module-scss-module__SZUyba__cardText",
  "cardTextWrp": "instructions-module-scss-module__SZUyba__cardTextWrp",
  "cardTitle": "instructions-module-scss-module__SZUyba__cardTitle",
  "clear": "instructions-module-scss-module__SZUyba__clear",
  "instructionsContent": "instructions-module-scss-module__SZUyba__instructionsContent",
});
